// import React, {useState, useEffect} from "react";
// import "./Termsconditions.css";
// import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner
// import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
// import {TermServices} from "../../utils/apis/termsofservice/TermsOfService";
// import { IDS } from "../../utils/common";

// const Termsconditions = () => {

//    const [banner, setBanner] = useState([]);

//     const getBanner = async () => {
//       try {
//         const res = await TermServices();

//         if (res?.success) {
//           setBanner(res?.data || []);
//         }
//       } catch (error) {
//         console.error("Error fetching customer testimonials:", error);
//       }
//     };

//     useEffect(() => {
//       getBanner();
//     }, []);

//   return (
//     <div className="terms-wrapper">
//       {/* ✅ Replaced old banner with Common_Banner */}
//       {/* <Common_Banner
//         imgSrc="/assets/images/termsandconditions/terms.png"
//         title="Terms & Conditions"
//       /> */}

//       <Common_Banner_2
//         imgSrc="/assets/images/home/commng-soon/agri_bg.png"
//         title_text="Terms & Conditions"
//       />

//       <div className="container  mt-5">
//         {/* Content Section */}

//         <h1>Terms & Conditions</h1>
//         <p class="updated">Last Updated: 11-06-2026</p>
//         <p> Welcome to the website of <strong>Seedso</strong> ("Company," "we," "our," or "us"). By accessing,
//           browsing, or using this Website ("www.seedso.in"), you acknowledge that you have read, understood, and agree to be
//           bound by these Terms & Conditions. If you do not agree with any part of these Terms, please refrain from using the
//           Website. </p>
//        <h2>1. Use of Website</h2>
// <p>
//   You agree to use this Website only for lawful purposes and in compliance with all applicable laws, regulations, and these Terms & Conditions.
// </p>

// <p>You shall not:</p>

// <ul>
//   <li>Use the Website in any manner that violates any applicable law or regulation.</li>
//   <li>Attempt to gain unauthorized access to any part of the Website, servers, databases, or systems connected to the Website.</li>
//   <li>Introduce viruses, malware, spyware, or any harmful code.</li>
//   <li>Copy, reproduce, distribute, modify, or exploit any Website content without prior written consent from Seedso Agro.</li>
//   <li>Engage in any activity that disrupts or interferes with the Website's functionality.</li>
// </ul>

// <h2>2. Intellectual Property Rights</h2>

// <p>All content available on this Website, including but not limited to:</p>

// <ul>
//   <li>Logos</li>
//   <li>Trademarks</li>
//   <li>Brand Names</li>
//   <li>Product Images</li>
//   <li>Graphics</li>
//   <li>Text</li>
//   <li>Videos</li>
//   <li>Designs</li>
//   <li>Website Layout & Software</li>
// </ul>

// <p>
//   is the exclusive property of Seedso Agro or its licensors and is protected under applicable intellectual property laws.
// </p>

// <p>
//   No content from this Website may be copied, reproduced, republished, uploaded, posted, transmitted, or distributed without prior written permission from Seedso Agro.
// </p>

// <h2>3. Product Information</h2>

// <p>
//   This Website provides information about Seedso Agro's fertilizers, crop nutrition products, bio-products, micronutrients, and agricultural solutions.
// </p>

// <p>
//   While we strive to ensure that all product descriptions, specifications, recommendations, and images are accurate and up to date, Seedso Agro does not guarantee that all information is complete, accurate, or free from errors.
// </p>

// <p>
//   Product specifications, packaging, availability, and pricing may change without prior notice.
// </p>

// <h2>4. Agricultural Usage Disclaimer</h2>

// <p>
//   Our products are intended for agricultural and farming purposes only.
// </p>

// <p>
//   Product performance may vary depending on soil type, weather conditions, irrigation practices, crop variety, farming methods, and other environmental factors.
// </p>

// <p>
//   Farmers are advised to follow the recommended dosage and application instructions or consult qualified agricultural experts before using any product.
// </p>

// <p>
//   Seedso Agro shall not be responsible for crop loss resulting from improper application, misuse, overuse, or environmental conditions beyond our control.
// </p>

// <h2>5. Third-Party Links</h2>

// <p>
//   This Website may contain links to third-party websites, distributors, dealers, partners, or social media platforms for your convenience.
// </p>

// <p>Seedso Agro does not control or guarantee:</p>

// <ul>
//   <li>Content available on third-party websites.</li>
//   <li>Accuracy of third-party information.</li>
//   <li>Product availability through distributors.</li>
//   <li>Delivery timelines or service quality.</li>
//   <li>Privacy practices of third-party websites.</li>
// </ul>

// <p>
//   Accessing third-party websites is entirely at your own risk and subject to their respective Terms & Conditions and Privacy Policies.
// </p>

// <h2>6. Limitation of Liability</h2>

// <p>
//   To the maximum extent permitted by law, Seedso Agro shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from:
// </p>

// <ul>
//   <li>Use or inability to use the Website.</li>
//   <li>Errors or omissions in Website content.</li>
//   <li>Website interruptions or technical failures.</li>
//   <li>Unauthorized access to Website systems.</li>
//   <li>Reliance on product information available on the Website.</li>
//   <li>Crop damage resulting from improper product usage.</li>
//   <li>Business losses, loss of profits, revenue, or data.</li>
// </ul>

// <h2>7. User Submissions</h2>

// <p>
//   Any feedback, suggestions, inquiries, reviews, or communications submitted through this Website become the property of Seedso Agro unless otherwise agreed in writing.
// </p>

// <p>By submitting content, you confirm that:</p>

// <ul>
//   <li>You own or have permission to submit the content.</li>
//   <li>The content does not violate any intellectual property rights.</li>
//   <li>The content is lawful, accurate, and not misleading or offensive.</li>
// </ul>

// <p>
//   Seedso Agro reserves the right to remove or edit any submitted content without prior notice.
// </p>

// <h2>8. Modification of Terms</h2>

// <p>
//   Seedso Agro reserves the right to update or modify these Terms & Conditions at any time without prior notice.
// </p>

// <p>
//   Continued use of the Website after any changes constitutes acceptance of the revised Terms.
// </p>

// <h2>9. Governing Law and Jurisdiction</h2>

// <p>
//   These Terms & Conditions shall be governed by the laws of India.
// </p>

// <p>
//   Any disputes arising from the use of this Website shall be subject to the exclusive jurisdiction of the competent courts in Pune, Maharashtra, India.
// </p>

// <h2>10. Contact Information</h2>

// <div class="contact-box">
//   <p><strong>Seedso Agro</strong></p>
//   <p><strong>Email:</strong> info@seedsoagro.com</p>
//   <p><strong>Phone:</strong> +91 XXXXXXXXXX</p>
//   <p><strong>Address:</strong> Your Registered Office Address, Pune, Maharashtra, India.</p>
// </div>
//       </div>
//     </div>
//   );
// };

// export default Termsconditions;

import React, { useState, useEffect } from "react";
import "./Termsconditions.css";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import { TermServices } from "../../utils/apis/termsofservice/TermsOfService";

const Termsconditions = () => {
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    try {
      const res = await TermServices();

      if (res?.success) {
        setBanner(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  // Get latest updatedAt
  const latestUpdatedDate =
    banner?.length > 0
      ? [...banner].sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
        )[0]?.updatedAt
      : null;

  // Format date
  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="terms-wrapper">
      <Common_Banner_2
        imgSrc="/assets/images/home/commng-soon/agri_bg.png"
        title_text="Terms & Conditions"
      />

      <div className="container mt-5">
        <h1>Terms & Conditions</h1>

        {/* Latest Updated Date */}
        <p className="updated">Last Updated: {formatDate(latestUpdatedDate)}</p>

        {/* Dynamic Terms Content */}
        {banner?.map((item, index) => (
          <div key={item?.id || index}>
            <h2>
              {index + 1}. {item?.name}
            </h2>

            <div
              dangerouslySetInnerHTML={{
                __html: item?.description || "",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Termsconditions;
